/* src/app/modals/cbm-detail/cbm-detail.component.scss */
@keyframes ldio-okxz8jkbhq-1 {
  0% {
    top: 12.5px;
    height: 75px;
  }
  50% {
    top: 25px;
    height: 50px;
  }
  100% {
    top: 25px;
    height: 50px;
  }
}
@keyframes ldio-okxz8jkbhq-2 {
  0% {
    top: 15.625px;
    height: 68.75px;
  }
  50% {
    top: 25px;
    height: 50px;
  }
  100% {
    top: 25px;
    height: 50px;
  }
}
@keyframes ldio-okxz8jkbhq-3 {
  0% {
    top: 18.75px;
    height: 62.5px;
  }
  50% {
    top: 25px;
    height: 50px;
  }
  100% {
    top: 25px;
    height: 50px;
  }
}
.ldio-okxz8jkbhq div {
  position: absolute;
  width: 12px;
}
.ldio-okxz8jkbhq div:nth-child(1) {
  left: 19px;
  background: #f2d155;
  animation: ldio-okxz8jkbhq-1 1s cubic-bezier(0, 0.5, 0.5, 1) infinite;
  animation-delay: -0.2s;
}
.ldio-okxz8jkbhq div:nth-child(2) {
  left: 44px;
  background: #f2d155;
  animation: ldio-okxz8jkbhq-2 1s cubic-bezier(0, 0.5, 0.5, 1) infinite;
  animation-delay: -0.1s;
}
.ldio-okxz8jkbhq div:nth-child(3) {
  left: 69px;
  background: #f2d155;
  animation: ldio-okxz8jkbhq-3 1s cubic-bezier(0, 0.5, 0.5, 1) infinite;
  animation-delay: undefineds;
}
.loadingio-spinner-pulse-uq8kufhdmv {
  width: 100px;
  height: 100px;
  display: inline-block;
  overflow: hidden;
  background: none;
}
.ldio-okxz8jkbhq {
  width: 100%;
  height: 100%;
  position: relative;
  transform: translateZ(0) scale(1);
  backface-visibility: hidden;
  transform-origin: 0 0;
}
.ldio-okxz8jkbhq div {
  box-sizing: content-box;
}
._tooltip {
  display: none;
  position: absolute;
  margin-top: 14px;
  font-family: "Helvetica Neue", serif;
  font-size: 13px;
  background-color: #00b7bd;
  padding: 7px;
  color: #FFF;
}
@keyframes ldio-okxz8jkbhq-1 {
  0% {
    top: 12.5px;
    height: 75px;
  }
  50% {
    top: 25px;
    height: 50px;
  }
  100% {
    top: 25px;
    height: 50px;
  }
}
@keyframes ldio-okxz8jkbhq-2 {
  0% {
    top: 15.625px;
    height: 68.75px;
  }
  50% {
    top: 25px;
    height: 50px;
  }
  100% {
    top: 25px;
    height: 50px;
  }
}
@keyframes ldio-okxz8jkbhq-3 {
  0% {
    top: 18.75px;
    height: 62.5px;
  }
  50% {
    top: 25px;
    height: 50px;
  }
  100% {
    top: 25px;
    height: 50px;
  }
}
.ldio-okxz8jkbhq div {
  position: absolute;
  width: 12px;
}
.ldio-okxz8jkbhq div:nth-child(1) {
  left: 19px;
  background: #f2d155;
  animation: ldio-okxz8jkbhq-1 1s cubic-bezier(0, 0.5, 0.5, 1) infinite;
  animation-delay: -0.2s;
}
.ldio-okxz8jkbhq div:nth-child(2) {
  left: 44px;
  background: #f2d155;
  animation: ldio-okxz8jkbhq-2 1s cubic-bezier(0, 0.5, 0.5, 1) infinite;
  animation-delay: -0.1s;
}
.ldio-okxz8jkbhq div:nth-child(3) {
  left: 69px;
  background: #f2d155;
  animation: ldio-okxz8jkbhq-3 1s cubic-bezier(0, 0.5, 0.5, 1) infinite;
  animation-delay: undefineds;
}
.loadingio-spinner-pulse-uq8kufhdmv {
  width: 100px;
  height: 100px;
  display: inline-block;
  overflow: hidden;
  background: none;
}
.ldio-okxz8jkbhq {
  width: 100%;
  height: 100%;
  position: relative;
  transform: translateZ(0) scale(1);
  backface-visibility: hidden;
  transform-origin: 0 0;
}
.ldio-okxz8jkbhq div {
  box-sizing: content-box;
}
._tooltip {
  display: none;
  position: absolute;
  margin-top: 14px;
  font-family: "Helvetica Neue", serif;
  font-size: 13px;
  background-color: #00b7bd;
  padding: 7px;
  color: #FFF;
}
.button {
  font-family: "Lato-Regular", serif;
  font-size: 18px;
  text-decoration: none;
  display: inline-block;
  margin: 5px;
  width: 290px;
  height: 50px;
  border-radius: 26px;
  border: none;
  padding: 10px;
  color: #5F96BA;
  outline: none !important;
}
.button:disabled {
  box-shadow: none;
  background-color: #BCBCBD !important;
  color: #797A7B !important;
  border: none;
}
.button:disabled:hover {
  box-shadow: none;
}
.button-default {
  outline: none !important;
  background-color: white;
  color: #5F96BA;
  border: 1px solid #5F96BA;
}
.button-default:hover {
  color: #284D76;
  background-color: #9FC6D8;
  border-color: #9FC6D8;
  box-shadow: 0px 8px 8px rgba(23, 28, 143, 0.1490196078);
}
.button-active {
  background-color: #5F96BA;
  color: #FFF;
}
.button-active:hover {
  background-color: #9FC6D8;
  color: #284D76;
  box-shadow: 0px 8px 8px rgba(23, 28, 143, 0.1490196078);
}
.button-disabled {
  background-color: #BCBCBD !important;
  color: white !important;
  border: none;
}
.button-disabled:hover {
  box-shadow: none;
}
.button-gradient {
  outline: none !important;
  background-image:
    linear-gradient(
      270deg,
      #171C8F,
      #00B7BD);
  color: white;
  border: none;
}
.button-gradient:hover {
  outline: none !important;
  box-shadow: 0px 8px 8px rgba(23, 28, 143, 0.1490196078);
}
@media screen and (max-width: 1000px) {
  .button {
    width: 275px;
    font-size: 15px;
  }
}
.modal_customer_body {
  width: 1209px;
  height: 614px;
  align-items: stretch;
  overflow: hidden;
  font-family: "Gotham-Book", serif;
  font-size: 18px;
}
._container {
  display: flex;
  width: 100%;
  height: 100%;
  flex-direction: row;
}
.cbm-details {
  padding: 30px 0px 0px 30px;
  flex: 1;
  width: 100%;
  height: 100%;
  align-items: flex-start;
}
.cbm-reviews {
  padding: 30px 0px 0px 30px;
  flex: 1;
  background-color: #F7F7F7;
}
.cbm-rating {
  font-family: "Gotham-Book", serif;
  display: flex;
  flex-direction: row;
  align-items: center;
  color: #9A9B9C;
}
.cbm-name {
  font-family: "Gotham-Bold", serif;
  font-size: 24px;
  color: #284D76;
}
.cbm-rating img {
  width: 22px;
  height: 22px;
}
.data-label {
  font-weight: bold;
  color: #9A9B9C;
}
.data-item {
  color: #333333;
  font-size: 18px;
  font-family: "Lato-Medium", serif;
}
.review-header {
  color: #284D76;
  font-size: 22px;
  font-weight: bold;
  font-family: Gotham-Bold, serif;
}
.review-container {
  overflow-y: scroll;
  min-height: 300px;
  max-height: 520px;
  width: 543px;
}
.review-container::-webkit-scrollbar {
  width: 0px;
  background: transparent;
}
.review-list {
  display: flex;
  flex-direction: column;
  align-items: center;
}
.review-item {
  width: 543px;
  padding: 20px;
  background-color: #FFF;
  border-radius: 5px;
  margin: 10px 0px;
}
.review-item-message {
  color: #333333;
}
.review-item-tags {
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
}
.review-item-tags div {
  font-family: "Helvetica Neue", serif;
  font-size: 13px;
  color: #58595B;
  border: 1px solid #A2A4D2;
  border-radius: 3px;
  padding: 4px 6px;
  display: inline-block;
  margin: 0px 5px 0px 0px;
}
.review-item-user {
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  font-family: "Gotham-Book", serif;
  font-size: 13px;
  color: #9A9B9C;
}
.review-item-stars {
  display: flex;
  flex-direction: row;
}
.review-item-stars img {
  width: 15px;
  height: 15px;
  margin-right: 3px;
}
.no-review {
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
  width: 100%;
  height: 448px;
  color: #797A7B;
  background-color: #EEEEEE;
  margin: 10px;
}
.cities {
  display: inline-block;
  white-space: pre-wrap;
  text-overflow: ellipsis;
  overflow: hidden;
  width: 460px;
  max-height: 200px;
  font-size: 18px;
  font-family: "Lato-Medium", serif;
}
.services {
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
  overflow: hidden;
  font-size: 18px;
  font-family: "Lato-Medium", serif;
}
.details-container {
  overflow-y: scroll;
  min-height: 300px;
  max-height: 520px;
  width: 543px;
}
.details-container::-webkit-scrollbar {
  width: 0px;
  background: transparent;
}
.view-all {
  color: #5F96BA;
  font-family: "Gotham-Book", serif;
  font-weight: bold;
  cursor: pointer;
  text-decoration: underline;
}
.expand-cities {
  max-height: unset;
  display: block;
  white-space: unset;
  text-overflow: unset;
  overflow: unset;
}
.star {
  width: 17px;
  height: 15px;
}
.button {
  width: 290px;
}
@media screen and (max-width: 1000px) {
  .modal_customer_body {
    width: 100%;
    font-size: 16px;
    padding: 2px !important;
  }
  ._container {
    justify-content: flex-start;
    flex-direction: column;
    height: 75vh;
    overflow-x: hidden;
    overflow-y: scroll;
    padding: 0px;
  }
  .details-container {
    overflow-y: unset;
    min-height: unset;
    max-height: unset;
    height: auto;
    width: 100%;
    margin: 0px;
  }
  .cbm-details {
    height: auto;
    max-height: unset;
    padding: 15px 15px;
  }
  .cities {
    width: 90%;
    max-height: 75px;
  }
  .cbm-reviews {
    width: 100%;
    padding: 15px 15px;
  }
  .review-container {
    overflow-y: unset;
    min-height: unset;
    max-height: unset;
    width: 100%;
  }
  ._container::-webkit-scrollbar {
    width: 0px;
    background: transparent;
  }
  .button {
    width: 70%;
    font-size: 15px;
    padding: 5px;
    margin: 0px;
  }
  .review-item {
    width: 100%;
  }
  .expand-cities {
    height: auto !important;
    max-height: unset;
  }
}
/*# sourceMappingURL=cbm-detail.component.css.map */
